@import "../../global/visualization-base.scss";

:host {
  --uui-variable-percent-bar-height: var(--uui-medium-padding);
}

.uui-variable-percent-bar {
  &-quantity {
    &.uui-dv-legend-label {
      margin-bottom: 0;
    }

    min-width: 30px;
    margin-right: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &-container {
    display: flex;
    align-items: center;
    position: relative;
    width: 100%;
    height: 100%;
  }

  &-segments {
    flex-grow: 1;
    position: relative;
    display: flex;
    align-items: center;
    height: var(--uui-variable-percent-bar-height);
  }

  &-segment {
    &:first-child {
      border-top-left-radius: var(--uui-medium-padding);
      border-bottom-left-radius: var(--uui-medium-padding);
    }

    &:last-child {
      border-top-right-radius: var(--uui-medium-padding);
      border-bottom-right-radius: var(--uui-medium-padding);
      margin-right: 0px;
    }

    height: 100%;
    position: relative;
    margin-right: 1px;
  }

  &-tooltip {
    &-container {
      @include tooltip-container;

      &-pointer {
        &-bottom {
          &:before {
            left: 46%;
          }
        }
      }
    }
  }
}